<template>
  <div>
    <van-search v-model="searchQuery" :placeholder="'搜索' + riverType" @search="onSearch" />
    <van-row type="flex" style="padding: 0 10px;">
      <van-col v-for="(item, index) in areaListArray" :key="index" span="6"
        @click="selectArea(index, item.value, item.name)"
        :style="{ background: (index == areaSelectIndex ? '#0081ff' : ''), color: (index == areaSelectIndex ? '#fffbf8' : '#000000') }">{{
          item.name }}</van-col>
    </van-row>

    <!-- <van-cell-group>
      <van-cell v-for="river in filteredRivers" :key="river.id" :title="river.name" @click="selectRiver(river)" />
    </van-cell-group> -->

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell v-for="item in rivers" :key="item.id" :title="item.name" :label="item.label">
        <!-- <template #icon>
          <van-image class="news-img" :src="getImage(item.imageId)"></van-image>
        </template> -->
        <template #right-icon>
          <van-radio :name="item" v-model="selectedId" />
        </template>
      </van-cell>
    </van-list>



  </div>
</template>

<script>
import { get } from '@/utils/api'
import { appOrPC, ipType, IMAGE_URL, interface_pubkey1, interface_prikey1 } from '@/utils/config';
export default {
  data() {
    return {
      searchQuery: '',
      rivers: [],
      riverType: localStorage.getItem('searchRiverType'),
      areaListArray: [],
      areaSelectIndex: "",
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 20,
      areaCode: "",
      selectedId: "",
      selectedName: "",
      IMAGE_URL: IMAGE_URL,
    };
  },
  // computed: {
  //   filteredRivers() {
  //     return this.rivers.filter(river =>
  //       river.name.includes(this.searchQuery)
  //     );
  //   }
  // },
  mounted() {
    this.getAreaData();
  },
  methods: {
    // selectRiver(river) {
    // this.$emit('selected', river);
    //   localStorage.setItem('riverSelected', JSON.stringify(river));
    //   this.$router.back();
    // },
    async getAreaData() {
      if (appOrPC) {
        let that = this, extraData = {
          header: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "App-Version-Code": "v2.0.0"
          }
        }
        this.areaListArray = [{ name: "不限", value: "" }]
        vaildInterfacefn(
          "hhwzzcsesonq",
          "rcshhwtyjksc",
          SM.encrypt(JSON.stringify({
            ipType: ipType,
            methodType: "get",
            methodName: "api/common/areaCodes",
            levelCode: "3"
          }), interface_pubkey1),
          "1",
          extraData
        ).then((value) => {
          if (value == false) {
            return;
          } else {
            const de_value = JSON.parse(SM.decrypt(value, interface_prikey1))
            if (de_value.code == 200 && de_value.success) {
              for (let i = 0; i < de_value.data.length; i++) {
                const element = de_value.data[i];
                that.areaListArray.push({
                  name: element.name,
                  value: element.areaCode
                })
              }
            } else {
              that.$toast.fail(de_value.message || '获取区域列表失败');
            }
          }
        })
      } else {
        const param = {
          levelCode: 3
        };
        this.areaListArray = [{ name: "不限", value: "" }]
        const res = await get('http://101.35.126.37:8081/api/common/areaCodes', param);
        if (res.code == 200 && res.success) {
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            this.areaListArray.push({
              name: element.name,
              value: element.areaCode
            })
          }
        } else {
          this.$toast.fail(res.message || '获取区域列表失败');
        }
      }
    },

    selectArea(index, val) {
      this.areaSelectIndex = index
      this.areaCode = val;
      this.finished = false
      this.loading = true
      this.rivers = []
      this.pageNo = 1
      this.onLoad()
    },

    onSearch() {
      this.rivers = []
      this.pageNo = 1
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onLoad() {
      this.getNewsDatas()
    },
    async getNewsDatas() {
      let riverType
      switch (this.riverType) {
        case '河道':
          riverType = "1"
          break;
        case '湖泊':
          riverType = "2"
          break;
        case '海湾':
          riverType = "4"
          break;
        default:
          break;
      }

      if (appOrPC) {
        let that = this, extraData = {
          header: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "App-Version-Code": "v2.0.0"
          }
        }, newsArray;
        vaildInterfacefn(
          "hhwzzcsesonq",
          "rcshhwtyjksc",
          SM.encrypt(JSON.stringify({
            ipType: ipType,
            methodType: "get",
            methodName: "api/app/geospatial/page",
            type: riverType,
            pageNo: that.pageNo,
            pageSize: that.pageSize,
            searchValue: that.searchQuery,
            areaCode: that.areaCode,
          }), interface_pubkey1),
          "1",
          extraData
        ).then((value) => {
          if (value == false) {
            return;
          } else {
            const de_value = JSON.parse(SM.decrypt(value, interface_prikey1))
            if (de_value.code == 200 && de_value.success) {
              newsArray = de_value.data.rows;
              for (let i = 0; i < newsArray.length; i++) {
                that.rivers.push({
                  id: newsArray[i].id,
                  name: newsArray[i].name,
                  label: newsArray[i].levelText,
                  imageId: (newsArray[i].images !== undefined && newsArray[i].images.length > 0) ? newsArray[i].images[0] : ''
                })
              }
            } else {
              that.$toast.fail(de_value.message || '获取列表信息失败');
            }
            that.loading = false
            that.pageNo++
            if (newsArray.length < 20) {
              that.finished = true
            }
          }
        })
      } else {
        const param = {
          type: riverType,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          searchValue: this.searchQuery,
          areaCode: this.areaCode,
        };
        const res = await get('/geospatial/page', param);
        let newsArray;
        // console.log(res, )
        if (res.code == 200 && res.success) {
          newsArray = res.data.rows;
          for (let i = 0; i < newsArray.length; i++) {
            this.rivers.push({
              id: newsArray[i].id,
              name: newsArray[i].name,
              label: newsArray[i].levelText,
              imageId: (newsArray[i].images !== undefined && newsArray[i].images.length > 0) ? newsArray[i].images[0] : ''
            })
          }
        } else {
          this.$toast.fail(res.message || '获取列表信息失败');
        }
        this.loading = false
        this.pageNo++
        if (newsArray.length < 20) {
          this.finished = true
        }
      }
    },
    getImage(id) {
      let token = localStorage.getItem("token")
      return IMAGE_URL + `?id=${id}&token=${token}`
    },
  },
  watch: {
    selectedId(v) {
      setTimeout(() => {
        localStorage.setItem('riverSelectedId', v.id);
        localStorage.setItem('riverSelectedName', v.name);
        this.$router.back();
      }, 1000);
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

li {
  cursor: pointer;
  padding: 8px;
  border: 1px solid #ccc;
  margin-bottom: 5px;
}

::v-deep(.van-col--6) {
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  line-height: 24px;
}

::v-deep(.van-cell__title) {
  margin-left: 14px;
}

.news-img {
  width: 40px;
  height: 40px;
}
</style>
